import styled from "styled-components";

export const StyledDiv = styled.div`
  display: block;
`;
